import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { MfaSetup } from '@/components/auth/MfaSetup'

export function MfaSetupPage() {
  const { user, adminUser, isLoading, isMfaSetupRequired } = useAuth()
  const navigate = useNavigate()

  // If not authenticated, redirect to login
  if (!isLoading && !user) {
    return <Navigate to="/login" replace />
  }

  // If MFA already enabled and NOT in mandatory setup flow, redirect
  if (!isLoading && adminUser?.mfa_enabled && !isMfaSetupRequired) {
    return <Navigate to={adminUser?.role === 'investor' ? '/investor' : '/dashboard'} replace />
  }

  const handleComplete = () => {
    navigate(adminUser?.role === 'investor' ? '/investor' : '/dashboard')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="absolute inset-0 bg-gradient-to-br from-dextoro/5 via-transparent to-transparent" />
      <div className="relative z-10">
        <MfaSetup
          mandatory={isMfaSetupRequired}
          onComplete={handleComplete}
        />
      </div>
    </div>
  )
}
